export const APP_SCROLL_CLASS = 'app-scroll';

export const APP_SCROLL_MEDIA_QUERY = '(min-width: 768px)';

export const APP_SUBHEADER_SLOT_ID = 'app-subheader-slot';
